export default function MapLegend(props) {
  return (
    <svg
    viewBox="0 0 90 300"
    height="270"
    width="90"
    align="center"
    margin-top="0"
    {...props}
  >
    <rect
      x="1"
      y="0"
      width="16"
      height="16"
      fill="#C40000"
      stroke="#6F0A46"
      strokeWidth="1px"
    ></rect>
    <rect
      x="1"
      y="18"
      width="16"
      height="16"
      fill="#D7452E"
      stroke="#941E63"
      strokeWidth="1px"
    ></rect>

  <line x1="20" y1="0" x2="25" y2="0" stroke="#4B4D4F" stroke-width="1" />
  <line x1="25" y1="0" x2="25" y2="34" stroke="#4B4D4F" stroke-width="1" />
  <line x1="20" y1="34" x2="25" y2="34" stroke="#4B4D4F" stroke-width="1" />

    <rect
      x="1"
      y="60"
      width="16"
      height="16"
      fill="#F3927E"
      stroke="#F03028"
      strokeWidth="1px"
    ></rect>
    <rect
      x="1"
      y="78"
      width="16"
      height="16"
      fill="#FBB6A6"
      stroke="#FF1A1A"
      strokeWidth="1px"
    ></rect>
    

<line x1="20" y1="60" x2="25" y2="60" stroke="#4B4D4F" stroke-width="1" />
<line x1="25" y1="60" x2="25" y2="94" stroke="#4B4D4F" stroke-width="1" />
<line x1="20" y1="94" x2="25" y2="94" stroke="#4B4D4F" stroke-width="1" />


    <rect
      x="1"
      y="120"
      width="16"
      height="16"
      fill="#FFFFF0"
      stroke="#AD8D01"
      strokeWidth="1px"
    ></rect>
    <rect
      x="1"
      y="138"
      width="16"
      height="16"
      fill="#C6E8DF"
      stroke="#15A796"
      strokeWidth="1px"
    ></rect>


<line x1="20" y1="120" x2="25" y2="120" stroke="#4B4D4F" stroke-width="1" />
<line x1="25" y1="120" x2="25" y2="154" stroke="#4B4D4F" stroke-width="1" />
<line x1="20" y1="154" x2="25" y2="154" stroke="#4B4D4F" stroke-width="1" />

    <rect
      x="1"
      y="180"
      width="16"
      height="16"
      fill="#89BFB2"
      stroke="#15A796"
      strokeWidth="1px"
    ></rect>
    <rect
      x="1"
      y="198"
      width="16"
      height="16"
      fill="#218371"
      stroke="#007000"
      strokeWidth="1px"
    ></rect>

<line x1="20" y1="180" x2="25" y2="180" stroke="#4B4D4F" stroke-width="1" />
<line x1="25" y1="180" x2="25" y2="214" stroke="#4B4D4F" stroke-width="1" />
<line x1="20" y1="214" x2="25" y2="214" stroke="#4B4D4F" stroke-width="1" />



     <rect
      x="1"
      y="240"
      width="16"
      height="16"
      fill="#F3F3F3"
      stroke="#6D6F70"
      strokeWidth="1px"
    ></rect>

    <line x1="21" y1="248" x2="26" y2="248" stroke="#4B4D4F" stroke-width="1"></line>

    <text
      x="30"
      y="25"
      style={{
        width: '57px',
        height: '16px',
        fontWeight: 400,
        fontSize: '12.64px',
      }}
    >
      Very High
    </text>
    <text
      x="30"
      y="80"
      style={{
        width: '57px',
        height: '16px',
        fontWeight: 400,
        fontSize: '12.64px',
      }}
    >
      High
    </text>
    <text
      x="30"
      y="140"
      style={{
        width: '57px',
        height: '16px',
        fontWeight: 400,
        fontSize: '12.64px',
      }}
    >
      Moderate
    </text>

<text
  x="30"
  y="197"
  style={{
    width: '57px',
    height: '16px',
    fontWeight: 400,
    fontSize: '12.64px',
  }}
>
  Low/Minimal
</text>

    <text
      x="30"
      y="252"
      style={{
        width: '57px',
        height: '16px',
        fontw: 400,
        fontSize: '12.64px',
      }}
    >
      No Data
    </text>
  </svg>
)
}